import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/i18n'; // i18next initialization
import './styles/global.css'; // Importing global CSS variables and base styles
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
